import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { FaBoxOpen, FaTruckMoving } from 'react-icons/fa'
import { FiCheckCircle } from 'react-icons/fi'
import useReferralAttribution from './useReferralAttribution'

const RegisterChoice = () => {
  const location = useLocation()
  const navigate = useNavigate()
  useReferralAttribution()
  const [isFading, setIsFading] = useState(false)
  const [selectedRole, setSelectedRole] = useState('')
  const timerRef = useRef(null)

  useEffect(() => {
    document.body.classList.add('hide-topbar')
    return () => {
      document.body.classList.remove('hide-topbar')
      if (timerRef.current) {
        window.clearTimeout(timerRef.current)
        timerRef.current = null
      }
    }
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const role = params.get('role')

    if (role === 'client') {
      navigate('/register/client', { replace: true })
    } else if (role === 'provider') {
      navigate('/register/provider', { replace: true })
    }
  }, [location.search, navigate])

  const handleNavigateWithFade = path => {
    if (isFading) {
      return null
    }
    setIsFading(true)
    timerRef.current = window.setTimeout(() => {
      timerRef.current = null
      navigate(path)
    }, 300)
    return null
  }

  const roleOptions = useMemo(
    () => [
      {
        key: 'client',
        title: 'Soy Cliente',
        eyebrow: 'Cliente / Generador de Carga',
        description:
          'Publica solicitudes, controla envíos y obtén transporte confiable en minutos.',
        Icon: FaBoxOpen,
      },
      {
        key: 'provider',
        title: 'Soy Proveedor',
        eyebrow: 'Proveedor / Aliado Logístico',
        description:
          'Ofrece tus servicios como transportista, vendedor, agente aduanal, almacén o custodia y conecta con nuevos clientes.',
        Icon: FaTruckMoving,
      },
    ],
    []
  )

  const handleCardSelect = key => {
    setSelectedRole(key)
  }

  const handleContinue = () => {
    if (!selectedRole) return
    handleNavigateWithFade(`/register/${selectedRole}`)
  }

  const handleBack = () => {
    handleNavigateWithFade('/')
  }

  return (
    <main className={`register-choice-page${isFading ? ' register-fade-out' : ''}`}>
      <div className="role-choice-container">
        <header className="role-choice-header">
          <h1>¿Cómo quieres usar Flotte?</h1>
          <p>Selecciona tu perfil para personalizar tu experiencia.</p>
        </header>

        <div className="role-choice-grid" role="radiogroup" aria-label="Selecciona tu perfil">
          {roleOptions.map(({ key, title, description, Icon }) => {
            const isSelected = selectedRole === key
            return (
              <button
                type="button"
                key={key}
                className={`role-choice-tile${isSelected ? ' is-selected' : ''}`}
                onClick={() => handleCardSelect(key)}
                role="radio"
                aria-checked={isSelected}
              >
                <span className="role-choice-tile__check" aria-hidden="true">
                  <FiCheckCircle />
                </span>
                <Icon className="role-choice-tile__icon" aria-hidden="true" />
                <h2>{title}</h2>
                <p>{description}</p>
              </button>
            )
          })}
        </div>

        <button
          type="button"
          className="role-choice-cta"
          onClick={handleContinue}
          disabled={!selectedRole}
        >
          Continuar
        </button>
        <button type="button" className="role-choice-back-link" onClick={handleBack}>
          Volver
        </button>
      </div>
    </main>
  )
}

export default RegisterChoice
